module.exports = __webpack_public_path__ + "assets/img/message-square.cb5104a4.svg";